import React, { useEffect, useState } from 'react';
import {
  Stepper,
  Step,
  StepLabel,
  Button,
  Typography,
  CircularProgress,
  Grid
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';

import { Formik, Form } from 'formik';
import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";
import validationSchema from './formik/validationSchema';
import { useHistory } from 'react-router-dom'
// import formInitialValues from './formik/formInitialValues';
import {GetInitialValuesToDocument} from './formik/formInitialValues';
import { ComponentByDocumentAndStep, StepsByDocument } from '../../components/StepsByDocuments';
import { snackAction } from '../../components/CustomSnakbar.jsx'
import { useParams } from "react-router-dom";
import { useDispatch, } from "react-redux";
import { postSendDocument } from "../../Store/Ducks/duckDocument";
import { useSnackbar } from "notistack";
import { objectToFormData } from '../../Utils/formUtils.js'
import moment from 'moment';
import {DOCUMENT_INVOICE_MASK, ROUTES} from '../../constants'
import { getCurrencies } from '../../Store/Ducks/duckCurrencies';
import { getReasons } from '../../Store/Ducks/duckReason';
import CustomSnackbarCollapse from '../../components/CustomSnackbarCollapse';
function _renderStepContent(step, documentType, values, setFieldValue) {

  return ComponentByDocumentAndStep(documentType, step, values, setFieldValue)
}

const useStyles = makeStyles((theme) => ({
  formControl: {
    marginTop: "10px",
    marginBottom: "10px",
  },
  containerGrid: {
    backgroundColor: "white",
    // border:"solid 1px black",
    boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.91)",
    padding: "30px"
  },
  buttonProgress:{
    marginLeft:"-50px",
  }
}));
export default function InvoiceStepper() {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  let { documentType } = useParams();
  const history = useHistory();
  const documentTypes = useSelector(store => store.documentType.data)
  const country = useSelector(store => store.countries?.data.find(item => item.selected)?.name);
  const validateXmlInvoice = useSelector(store => store.countries?.data.find(item => item.selected)?.validateXmlInvoice);
  const supplierList = useSelector(store => store.supplier?.data?.availablesCUIT)
  //let temporalDate='fer'
  const societies = useSelector(store => store.societies.data)

  const classes = useStyles();
  const [steps, setSteps] = useState(['Datos del documento', 'Adjuntos'])
  const [activeStep, setActiveStep] = useState(0);
  const currentValidationSchema = validationSchema[activeStep];
  const isLastStep = activeStep === steps.length - 1;
  let documentTypeId=documentTypes.find(x => x.description === documentType)?.id??0;

  function _sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  function validarEmail(elemento) {
    var regex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;

    if (!regex.test(elemento)) {
      return "Correo invalido";
    } else {
      return "";
    }

  }
  async function _submitForm(values, actions) {
    actions.setSubmitting(true);
    //temporalDate=values.documentDate
    values.documentTypeId = documentTypes.find(x => x.description === documentType).id
  
      //values.documentDate = moment(values.documentDate).format('YYYY-MM-DD')
      values.documentDate = moment(values.documentDate).utcOffset(0, true).format("YYYY-MM-DD HH:mm");
   
    let error = false;
    //const regexFileExtensions = /.PDF|.JPG|.TIF/;

    if (values.document.length === 0) {
      error = true;
      enqueueSnackbar(`No ha adjuntado documento`, { variant: "error", action: snackAction, autoHideDuration: null });
    }

    /* if(values.document.some(x=>!x.name.toUpperCase().match(regexFileExtensions))){
      error = true;
      enqueueSnackbar(`El adjunto debe ser PDF, JPG o TIF en ${values.documentTypeId===2?"Factura de Anticipo":"Documento"}`, { variant: "error", action: snackAction, autoHideDuration: null });
    } */

    if (!error) {
      if(supplierList.length>0)
        values.supplierInfo=supplierList.find(x=>x.cuit===values.supplierCUIT)
 
      let formData = objectToFormData(values);

      for (let i = 0; i < values.document.length; i++) {
        const element = values.document[i];
        formData.append("document", element)
      }
      if(values.insurances){
        for (let i = 0; i < values.insurances.length; i++) {
          const element = values.insurances[i];
          formData.append("insurances", element)
        }
      }
      if(values.otherSupports){      
        for (let i = 0; i < values.otherSupports.length; i++) {
          const element = values.otherSupports[i];
          formData.append("otherSupports", element)
        }
      }
      if(values.otherSupportsFiles){      
        for (let i = 0; i < values.otherSupportsFiles.length; i++) {
          const element = values.otherSupportsFiles[i];
          formData.append("otherSupports", element)
        }
      }
      dispatch(postSendDocument(formData,values.documentTypeId)).then(res => {
        enqueueSnackbar(`Documento enviado correctamente`, { variant: "success", action: snackAction, autoHideDuration: 2000 });
        history.push(ROUTES.HOME);
        actions.setSubmitting(false);
      })
        .catch((err) => {                
            //values.documentDate = temporalDate;
            console.log('erro',err)
          enqueueSnackbar(``, { action: snackAction, autoHideDuration: 8000, content: 
            <CustomSnackbarCollapse 
            key="Error-General" label={err?.response?.data?.title ?? err?.response?.data?.message ?? err.message} errorMessage={
                      <div>
                          {err?.response?.data?.error ?? getListValidationErrors(err?.response?.data?.errors) ?? err?.response?.data}            

              {/*{err?.response?.data?.error ?? err?.response?.data?.errors?.map((item)=>{return<><div>{item}</div><br/></>}) ?? err?.response?.data }            */}
              </div>
              } 
            />, });
          // resetForm();
      
          actions.setSubmitting(false);
        });
    } else {
      //values.documentDate = temporalDate;
      actions.setSubmitting(false);
      
    }
  }

    const getListValidationErrors = errors => {
      
        return <div><ul>
            {
                errors?.map(err => <li>{err}</li>)
            }
        </ul></div>

    } 
  function _handleSubmit(values, actions) {
    if (isLastStep) {
      _submitForm(values, actions);
    } else {
      let error = false;
      if (values.companyId === 0) {
        error = true;
        enqueueSnackbar(`No ha seleccionado SOCIEDAD`, { variant: "error", action: snackAction, autoHideDuration: 3000 });
      }

      if (values.currencyId === 0) {
        error = true;
        enqueueSnackbar(`No ha seleccionado Moneda`, { variant: "error", action: snackAction, autoHideDuration: 3000 });
      }

      if (validateXmlInvoice && values.documentTypeId === 5 && values.otherSupports !== '' && values.reasonId === 0) {
        error = true;
        enqueueSnackbar(`No ha seleccionado Motivo`, { variant: "error", action: snackAction, autoHideDuration: 3000 });
      }

      if (validateXmlInvoice && values.documentTypeId === 5 && (values.relatedInvoice === '' || values.relatedInvoice === null)) {
        error = true;
        enqueueSnackbar(`No ha ingresado Facturas Relacionadas`, { variant: "error", action: snackAction, autoHideDuration: 3000 });
      }

      if (values.supplierCUIT===0 || values.supplierCUIT==='') {
        error = true;
        enqueueSnackbar(`CUIT es requerido`, { variant: "error", action: snackAction, autoHideDuration: 3000 });
      }
      
      const inputDate = moment(values.documentDate).format('DD/MM/YYYY');
      if (values.documentDate === null || !moment(inputDate, 'DD/MM/YYYY', true).isValid()) {
        error = true;
        enqueueSnackbar(`Error en el formato de fecha DD/MM/YYYY`, {
            variant: "error",
            action: snackAction,
            autoHideDuration: 3000,
        });
      }
      
      if (values.documentNumber==='') {
        error = true;
        enqueueSnackbar(`El Nro ${(documentType==='Anticipo'?"Factura":documentType)} es requerido`, { variant: "error", action: snackAction, autoHideDuration: 3000 });
      }
      
      if (documentType.toUpperCase() === "ANTICIPO" && values.purchaseOrderNumber === ''){
        error = true;
        enqueueSnackbar(`ORDEN DE COMPRA es requerido`, { variant: "error", action: snackAction, autoHideDuration: 3000 });
      }

      if (documentType.toUpperCase() === "NOTA CRÉDITO"  && values.purchaseOrderNumber === '' && (values.reasonId === 3 || values.reasonId === 7)){
        error = true;
        enqueueSnackbar(`ORDEN DE COMPRA es requerido`, { variant: "error", action: snackAction, autoHideDuration: 3000 });
      }

      else if(DOCUMENT_INVOICE_MASK[country]?.regexValid!==null){
        if(!DOCUMENT_INVOICE_MASK[country]?.regexValid.test(values.documentNumber)){
          error = true;
          enqueueSnackbar(``, { action: snackAction, autoHideDuration: 3000, content: 
            <CustomSnackbarCollapse
            key="Error-General" label={`El Nro ${(documentType==='Anticipo'?"Factura":documentType)} tiene formato incorrecto`} errorMessage={
              <React.Fragment>
              <Typography gutterBottom>El formato correcto debe ser:</Typography>        
              <Typography gutterBottom>
                {DOCUMENT_INVOICE_MASK[country].placeholder}
              </Typography>        
              {DOCUMENT_INVOICE_MASK[country].description}
              </React.Fragment>
              } 
            />, }); 
        }
               
      }

      if (isNaN(values.amount) || values.amount.length===0) {
        error = true;
        enqueueSnackbar(`Importe debe ser decimal`, { variant: "error", action: snackAction, autoHideDuration: 3000 });
      }

      if (isNaN(values?.exchangeRate) || values?.exchangeRate.length===0) {
        error = true;
        enqueueSnackbar(`Tipo de cambio debe ser decimal`, { variant: "error", action: snackAction, autoHideDuration: 3000 });
      }

      if (validarEmail(values.supplierEmail).length > 0) {
        error = true;
        enqueueSnackbar(`Email Incorrecto`, { variant: "error", action: snackAction, autoHideDuration: 3000 });
      }
      if (!error) {
        values.amount=values.amount.replace(',','.')
          values.exchangeRate = values.exchangeRate.replace(',','.')
        // values.documentTypeId=documentTypes.find(x=>x.description===documentType).id
        setActiveStep(activeStep + 1);
        actions.setTouched({});
      }
      actions.setSubmitting(false);
    }
  }

  function _handleBack() {
    setActiveStep(activeStep - 1);
  }
  function _handleCancel() {
    history.push(ROUTES.HOME)
  }

  React.useEffect(() => {
    if (societies && societies.filter(x => x.selected).length === 0) {
      history.push(ROUTES.HOME)
    }
  }, [history, societies])
  return (
    <Grid className={classes.containerGrid}>
      <Typography marginBottom={2} fontSize={20}>Carga {documentType}</Typography>
      <Stepper activeStep={activeStep} className={classes.stepper}>
        {steps.map(label => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      <React.Fragment>
        {activeStep === steps.length ? (
         /*  <CheckoutSuccess /> */<>Success</>
        ) : (
          <Formik
            initialValues={GetInitialValuesToDocument(documentTypeId)}
            // validationSchema={currentValidationSchema}
            onSubmit={_handleSubmit}
          >
            {({ setFieldValue, values, isSubmitting }) => (

              <Form  style={{ marginLeft: "10px" }}>
                {_renderStepContent(activeStep, documentType, values, setFieldValue)}

                <Grid marginTop={4} container spacing={4} className={classes.buttons}>
                  <Grid container
                    direction="row"
                    justifyContent="flex-end"
                    alignItems="center" item xs >
                    <Grid item>
                      {activeStep !== 0 ? (
                        <Button onClick={_handleBack} className={classes.button}>
                          Back
                        </Button>
                      ):
                      (
                        <Button onClick={_handleCancel} className={classes.button}>
                          Cancel
                        </Button>
                      )}
                    </Grid>
                  </Grid>
                  <Grid item xs>
                                          <div className={classes.wrapper}>
                                              <LoadingButton color="primary"
                                                  loading={isSubmitting}
                                                  variant="contained"
                                                  type="submit"
                                                  className={classes.button}
                                              >
                                                  {isLastStep ? 'Send' : 'Next'}
                                              </LoadingButton>
                      {/*<Button*/}
                      {/*  disabled={isSubmitting}*/}
                      {/*  type="submit"*/}
                      {/*  variant="contained"*/}
                      {/*  color="primary"*/}
                      {/*  className={classes.button}*/}
                      {/*>*/}
                      {/*  {isLastStep ? 'Send' : 'Next'}*/}
                      {/*</Button>*/}
                      {/*{isSubmitting && (*/}
                      {/*  <CircularProgress*/}
                      {/*    size={24}*/}
                      {/*    className={classes.buttonProgress}*/}
                      {/*  />*/}
                      {/*)}*/}
                    </div>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        )}
      </React.Fragment>
    </Grid>
  );
}
